<template lang="html">
	<div class="compare" v-show="showRecommendations">
		<div class="overlay">
			<div class="top-content">
				<div class="clearfix">
					<div class="f-l main-title">Quotation Recomendations</div>
					<div
						class="close-modal f-r"
						@click="$store.commit('showRecommendations', false)"
					>
						<i class="fa fa-times"></i>
					</div>
				</div>
			</div>

			<!-- <CartPaymentIntermediary @on-confirm="addToCart"/> -->

			<div class="no-content" v-if="recommendations.length == 0">
				<div class="title">No Recomendations Found!</div>
			</div>
			<div class="area" v-if="recommendations.length > 0">
				<scrollbar>
					<!-- <div class="sc-content clearfix" :style="`width: ${(recommendations.length * 370) + 20}px`">
                  <div class="quotation-card f-l" v-for="(quotation,i) of recommendations" :key="i">
                     <div class="clearfix">
                        <div class="image-box f-l">
                           <img v-if="quotation.product.logo && quotation.product.logo.trim !== ''" :src="`${api.getDomain()}${quotation.product.logo}`" alt="" class="image">
                           <img v-else src="/img/logo-1.png" alt="" class="image">
                        </div>
                        <div class="right-content f-l">
                           <div class="title">{{quotation.product.product_name}}</div>
                           <div class="offer-box">
                              <div class="offer tx-red">{{quotation.preferred_currency}} {{utils.numberWithCommas(quotation.premium_amount)}}</div>
                              <div class="save">Sum Assured {{quotation.preferred_currency}} {{utils.numberWithCommas(quotation.sum_assured)}}</div>
                           </div>
                        </div>
                     </div>
                     <div class="ratings clearfix">
                        <Rate 
                           class="f-l rate"
                           disabled
                           :allow-half="true"
                           v-model="quotation.product.rating" 
                        />
                        <div class="reviews f-l">({{quotation.product.ranking}} Reviews)</div>
                        <div class="icon f-l"></div>
                     </div>
      
                     <div class="prod-rate">Recomendation Level: {{quotation.recommendation_level}}</div>
                     <div class="underwritter">{{quotation.underwriter}}</div>
                     <div>
                        <div class="title">Benefit</div>
                     <div>
                        <div v-for="(benefit, index) in quotation.benefit_details" :key="index">  
                        {{ benefit.name }} 
                        </div>
                     </div>
                  </div>
                     <div class="flex  mt-4">
                        <div class="btn btn-red mx-4 btn-long">
                           Decline
                        </div>
                        <div class="btn btn-green mx-4 btn-long" @click="acceptQuotation(quotation, 'INTER')">
                           Accept
                        </div>
                     </div>
                  </div>
               </div> -->

					<table class="w-full table-auto border border-gray-200">
						<thead>
							<tr class="bg-gray-100">
								<th
									class="px-4 py-2 text-left text-sm font-medium text-gray-700 border border-gray-200"
								></th>
								<th
									v-for="(quotation, i) in recommendations"
									:key="'head-' + i"
									class="px-4 py-2 text-center border border-gray-200"
								>
									<div
										class="flex justify-center items-center"
									>
										<img
											v-if="
												quotation.product.logo &&
												quotation.product.logo.trim() !==
													''
											"
											:src="`${api.getDomain()}${quotation.product.logo}`"
											alt=""
											class="w-8 h-8 object-contain"
										/>
										<img
											v-else
											src="/img/logo-1.png"
											alt=""
											class="w-8 h-8 object-contain"
										/>
									</div>
								</th>
							</tr>
						</thead>
						<tbody class="bg-white">
							<tr class="hover:bg-gray-50">
								<td
									class="px-4 py-2 font-semibold border border-gray-200"
								>
									Product Name
								</td>
								<td
									v-for="quotation in recommendations"
									:key="
										'name-' + quotation.product.product_name
									"
									class="px-4 py-2 border border-gray-200"
								>
									{{ quotation.product.product_name }}
								</td>
							</tr>
							<tr class="hover:bg-gray-50">
								<td
									class="px-4 py-2 font-semibold border border-gray-200"
								>
									Product Description
								</td>
								<td
									v-for="quotation in recommendations"
									:key="
										'name-' + quotation.product.description
									"
									class="px-4 text-sm py-2 border border-gray-200"
								>
									{{ quotation.product.description }}
								</td>
							</tr>
							<tr class="hover:bg-gray-50">
								<td
									class="px-4 py-2 font-semibold border border-gray-200"
								>
									Premium
								</td>
								<td
									v-for="quotation in recommendations"
									:key="
										'premium-' +
										quotation.product.product_name
									"
									class="px-4 py-2 border border-gray-200"
								>
									{{ quotation.preferred_currency }}
									{{
										utils.numberWithCommas(
											quotation.premium_amount,
										)
									}}
								</td>
							</tr>
							<tr class="hover:bg-gray-50">
								<td
									class="px-4 py-2 font-semibold border border-gray-200"
								>
									Sum Assured
								</td>
								<td
									v-for="quotation in recommendations"
									:key="
										'sum-' + quotation.product.product_name
									"
									class="px-4 py-2 border border-gray-200"
								>
									{{ quotation.preferred_currency }}
									{{
										utils.numberWithCommas(
											quotation.sum_assured,
										)
									}}
								</td>
							</tr>
							<tr class="hover:bg-gray-50">
								<td
									class="px-4 py-2 font-semibold border border-gray-200"
								>
									Rating
								</td>
								<td
									v-for="quotation in recommendations"
									:key="
										'rating-' +
										quotation.product.product_name
									"
									class="px-4 py-2 border border-gray-200"
								>
									<Rate
										disabled
										:allow-half="true"
										v-model="quotation.product.rating"
									/>
									<div class="text-xs text-gray-500 mt-1">
										({{ quotation.product.ranking }}
										Reviews)
									</div>
								</td>
							</tr>
							<tr class="hover:bg-gray-50">
								<td
									class="px-4 py-2 font-semibold border border-gray-200"
								>
									Recommendation Level
								</td>
								<td
									v-for="quotation in recommendations"
									:key="
										'level-' +
										quotation.product.product_name
									"
									class="px-4 py-2 border border-gray-200"
								>
									{{ quotation.recommendation_level }}
								</td>
							</tr>
							<tr class="hover:bg-gray-50">
								<td
									class="px-4 py-2 font-semibold border border-gray-200"
								>
									Underwriter
								</td>
								<td
									v-for="quotation in recommendations"
									:key="
										'underwriter-' +
										quotation.product.product_name
									"
									class="px-4 py-2 border border-gray-200"
								>
									{{ quotation.underwriter }}
								</td>
							</tr>
							<tr class="hover:bg-gray-50 align-top">
								<td
									class="px-4 py-2 font-semibold border border-gray-200"
								>
									Benefits
								</td>
								<td
									v-for="quotation in recommendations"
									:key="
										'benefits-' +
										quotation.product.product_name
									"
									class="px-4 py-2 border border-gray-200"
								>
									<ul
										class="list-disc list-inside text-sm text-gray-700 space-y-1"
									>
										<li
											v-for="(
												benefit, index
											) in quotation.benefit_details"
											:key="index"
										>
											{{ benefit.name || 'Not Provided' }}
										</li>
									</ul>
								</td>
							</tr>
							<tr class="hover:bg-gray-50">
								<td
									class="px-4 py-2 font-semibold border border-gray-200"
								>
									Action
								</td>
								<td
									v-for="(
										quotation, index
									) in recommendations"
									:key="
										'actions-' +
										quotation.product.product_name
									"
									class="px-4 py-2 border border-gray-200"
								>
									<div class="flex gap-2 justify-center">
										<!-- <button 
                        class="bg-gray-400 hover:bg-gray-500 text-white py-1 px-3 rounded"
                        @click="removeRecommendation(index)"
                        >
                        Clear
                        </button> -->
										<button
											class="bg-red-500 hover:bg-red-600 text-white py-1 px-3 rounded"
										>
											Decline
										</button>
										<button
											class="bg-green-500 hover:bg-green-600 text-white py-1 px-3 rounded"
											@click="
												acceptQuotation(
													quotation,
													'INTER',
												)
											"
										>
											Accept
										</button>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</scrollbar>
			</div>
		</div>
	</div>
</template>

<script>
import VueScrollbar from 'vue-scrollbar-simple';

export default {
	components: {
		scrollbar: VueScrollbar,
		Rate: () => import('@/libs/clarks/components/rate/'),
		// CartPaymentIntermediary: () => import("../../newportal/templates/others/cart-payment-intermediary"),
	},
	computed: {
		...mapGetters(['recommendations', 'showRecommendations']),
	},
	data() {
		return {
			api,
			utils,
			gateway: process.env.VUE_APP_GATEWAY,
			show_cover_type: true,
			show_premium_range: false,
			show_insurer: false,
		};
	},
	methods: {
		...mapActions(['fetchRecommendations', 'acceptQuotation', 'addToCart']),
		removeRecommendation(index) {
			console.log('testing oo', index);
			this.$store.commit('removeQuotationByIndex', index);
		},
	},
	async mounted() {},
};
</script>

<style lang="less">
.compare {
	.overlay {
		-webkit-backdrop-filter: blur(1px);
		backdrop-filter: blur(1px);
		background-color: rgba(0, 0, 0, 0.7);
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 3200;
		overflow-y: auto;

		.close-btn {
			cursor: pointer;
			position: absolute;
			right: 10px;

			&:hover {
				color: var(--ne-red);
			}
		}
		.no-content {
			background: var(--white);
			border-radius: 4px;
			border: solid 1px #e6eaee;
			padding: 40px 0;
			text-align: center;
			font-size: 14px;
			margin: 40px 20px;
			font-weight: 600;
			color: var(--ne-red);
		}
		.top-content {
			padding: 20px;

			.main-title {
				color: var(--ne-yellow);
				font-weight: 600;
				font-size: 18px;
				margin: 10px 0 0 0;
			}
		}
	}

	.area {
		padding: 0 0 30px 0;
		position: absolute;
		z-index: 1500;
		left: 0;
		right: 0;
		top: 80px;
		bottom: 20px !important;

		.sc-content {
			width: auto;
			min-width: 100vw;
			display: flex;
		}
		.quotation-card {
			background: var(--white);
			border-radius: 3px;
			padding: 10px;
			width: 340px;
			margin: 0 10px 0 10px;
			padding-bottom: 90px;
			position: relative;

			.prod-rate {
				color: var(--ne-green);
				font-weight: 600;
				font-size: 12px;
			}
			.features {
				margin: 3px 0;
				font-size: 13px;
				color: #a7abbd;

				.name {
				}
				.icon {
					margin: 2px 10px 0 0;
					font-size: 12px;
				}
			}
			.actions {
				position: absolute;
				bottom: 20px;
				right: 0;

				.fa {
					margin: 20px 10px;
					cursor: pointer;

					&.fa-shopping-cart:hover {
						color: var(--ne-green);
					}
					&.fa-ban:hover {
						color: var(--ne-red);
					}
				}
			}
			.right-content {
				width: calc(100% - 120px);
			}
			.offer-box {
				text-align: left;
				margin: 0 15px 0 0;

				.regular {
					color: var(--text-grey);
					font-family: var(--font-bold);
					font-size: 13px;
				}
				.offer {
					font-size: 16px;
					font-family: var(--font-bold);
				}
				.save {
					font-size: 12px;
					color: var(--text-grey);
				}
			}
			.ratings {
				margin: 20px 0 0 0;

				.reviews {
					color: #7f8fa4;
					font-size: 13px;
				}
				.rate {
					font-size: 13px !important;
				}
			}
			.image-box {
				text-align: center;

				.image {
					height: auto;
					width: auto;
					max-height: 110px;
					max-width: 110px;
					margin: 0 10px 0 0;
					transition: all 1s ease-in;
				}
			}
			.title {
				font-size: 15px;
				font-weight: 600;
				color: var(--primary);
				margin: 5px 0 0 0;
			}
			.benefits {
				bottom: 30px;
			}
			.desc {
				font-size: 13px;
				height: 60px;
				white-space: initial;
				overflow: hidden;
				text-overflow: ellipsis;
				margin: 3px 0 0 0;
			}

			.underwritter {
				font-size: 13px;
				font-weight: 600;
				color: var(--primary);
			}
		}
	}
}
</style>
